import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';

import { TerraUtils } from 'src/app/shared/TerraUtils';
import { UserService } from 'src/app/services/shared/user.service';
import { RoutingService } from 'src/app/services/routing.service';
import { CustomValidators } from 'src/app/shared/validators/custom.validators';
import { ReCaptcha2Component } from 'ngx-captcha';
import { ForgotPasswordDto } from './forget-password.model';
import { AppSettingsService, SubdomainEnum } from 'src/app/services/app-settings.service';
import HTTP_STATUS_CODES from 'src/app/shared/enums/HttpStatusCodesEnum';

@Component({
  selector: 'terra-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  loginUrlTree = this.routingService.loginUrlBySubdomain;

  isLoading = false;

  usernameFormGroup: UntypedFormGroup;
  usernameFormGroupSubmitted = false;

  private CAPTCHA_INVALID = 3;
  submit:boolean = false;
  hasError = false

  @ViewChild('recaptcha') recaptcha: ReCaptcha2Component;

  ForgotPasswordEmail = '';

  referrerLogo$ = this.appSettingsService.subDomain === SubdomainEnum.GP ? this.userService.gp_referrerLogo$ : this.userService.lp_referrerLogo$;
  
  constructor(
    private userService: UserService,
    private titleService: Title,
    public routingService: RoutingService,
    public appSettingsService: AppSettingsService
    ) {

    this.usernameFormGroup = new UntypedFormGroup({
      username: new UntypedFormControl('', Validators.compose([Validators.required, CustomValidators.EmailWithSpaces])),
      recaptcha: new UntypedFormControl('', [CustomValidators.requiredIf(() => 
        !this.appSettingsService.isTestingEnv && !this.appSettingsService.isAutomationEnv)])
    });

  }

  ngOnInit() {
    this.titleService.setTitle('Forgot Your Password?');
  }

  public forgotPassword() {
    this.usernameFormGroupSubmitted = false;
    this.submit = true;
    this.hasError = false;

    if (this.isLoading) {
      return;
    }

    if (this.usernameFormGroup.invalid) {
      this.usernameFormGroup.get('username').markAsTouched();
      return;
    }
    this.isLoading = true;

    const forgotPasswordDto = new ForgotPasswordDto();
    forgotPasswordDto.username = this.usernameFormGroup.get('username').value;
    forgotPasswordDto.recaptchaToken = this.usernameFormGroup.get('recaptcha').value;

    this.userService
      .forgotPassword(forgotPasswordDto)
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.submit = false;
          this.usernameFormGroup.reset();
          this.recaptcha && this.recaptcha.resetCaptcha();
        })
      )
      .subscribe(
        result => {
          this.hasError = false;
          this.ForgotPasswordEmail = forgotPasswordDto.username;
          this.usernameFormGroupSubmitted = true;
        },
        err => {
          this.hasError = true;
          // if(err.status === HTTP_STATUS_CODES.BAD_REQUEST && !!err.error && err.error.message == this.CAPTCHA_INVALID){
          //   console.log("error captcha");
          // }
        }
      );
  }
}
